export default __webpack_public_path__ + "static/media/esrb_rating_teen2.8360c298.jpg";